export interface PlacedRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

/** Uniform scale to fit image inside container; centered. No non-uniform stretch. */
export function getContainRect(containerW: number, containerH: number, imgW: number, imgH: number): PlacedRect | null {
  if (!imgW || !imgH) return null;
  const scale = Math.min(containerW / imgW, containerH / imgH);
  const width = imgW * scale;
  const height = imgH * scale;
  return { x: (containerW - width) / 2, y: (containerH - height) / 2, width, height };
}

/** Uniform scale so the image covers the container; centered (overflow is cropped). */
export function getCoverRect(containerW: number, containerH: number, imgW: number, imgH: number): PlacedRect | null {
  if (!imgW || !imgH) return null;
  const scale = Math.max(containerW / imgW, containerH / imgH);
  const width = imgW * scale;
  const height = imgH * scale;
  return { x: (containerW - width) / 2, y: (containerH - height) / 2, width, height };
}
